import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  environment: 'preprod',
  resource: 'task',
  action: 'getTasks',
  boardId: '',
  taskId: '',
  columnId: '',
  targetColumnId: '',
  tagId: '',
  memberId: '',
  stakeholderId: '',
  stakeholderTypeId: '',
  taskTypeId: '',
  commentId: '',
  teamId: '',
  filterBoardId: '',
  filterColumnId: '',
  // Note: body default is defined in schema.ts
};

export default defaults;
